module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td class="center">'+
((__t=( from_date ))==null?'':__t)+
'</td>\r\n<td class="center">'+
((__t=( to_date ))==null?'':__t)+
'</td>\r\n<td class="center" style="min-width: 200px;">'+
((__t=( visits ))==null?'':__t)+
'</td>\r\n<td class="center" style="min-width: 200px;">'+
((__t=( number_of_periods ))==null?'':__t)+
'</td>\r\n<td class="center" style="min-width: 10px;">'+
((__t=( prn ))==null?'':__t)+
'</td>\r\n<td class="center" style="min-width: 120px;">'+
((__t=( orderedby == 'O' ? 'Physician Ordered' : (orderedby == 'S' ? 'Suggested by HH' : 'Final') ))==null?'':__t)+
'</td>\r\n<td style="min-width: 220px;" class="center">'+
((__t=( visits_number ))==null?'':__t)+
'</td>\r\n<td class="center">'+
((__t=( visit_time ))==null?'':__t)+
''+
((__t=( frequency_name ))==null?'':__t)+
'</td>\r\n<td class="center" style="min-width: 200px;">'+
((__t=( frequency_comment ))==null?'':__t)+
'</td>\r\n<td class="center" style="min-width: 200px;">\r\n    ';
 if (created_docs) { 
__p+='\r\n    <button class="btn btn-primary btn-sm rns-created-doc">Created</button>\r\n    ';
 } 
__p+='\r\n    ';
 if (canceled_docs) { 
__p+='\r\n    <button class="btn btn-primary btn-sm rns-canceled-doc">Canceled</button>\r\n    ';
 } 
__p+='\r\n</td>\r\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/organizations/organization-patients-jf-row.html
// module id = 295
// module chunks = 0